const unavailableStorage = new Map<string,string>()
export const popupStore = {
 read(key:string,session=false):string|null {const id=`${session}:${key}`;try{return (session?window.sessionStorage:window.localStorage).getItem(key)??unavailableStorage.get(id)??null}catch{return unavailableStorage.get(id)??null}},
 write(key:string,value:string,session=false) {const id=`${session}:${key}`;try{(session?window.sessionStorage:window.localStorage).setItem(key,value);unavailableStorage.delete(id)}catch{unavailableStorage.set(id,value)}}
}
export const popupEnvironment=(process.env.REACT_APP_ENVIRONMENT || process.env.ENVIRONMENT || 'prod').trim().toLowerCase()
export const popupKey=(kind:string,decision:any)=>{
 const display={...(decision.popup?.snapshot?.display||{}),...(decision.display||{})}
 const scope=kind==='signed-up'?'offer':display.frequencyScope||'node'
 const id=scope==='offer'&&decision.offerId?`offer:${decision.offerId}`:scope==='flow'?`flow:${decision.flowId}`:`${decision.flowId||''}:${decision.flowNodeId||decision.popupVariantId||''}`
 return `journey-popup:${popupEnvironment}:${kind}:${id}`
}
export const isPopupCheckout=(path:string)=>/^\/(?:[a-z]{2}\/)?(?:(?:shop\/)?checkout|post-purchase-survey|order-confirmation)(?:\/|$)/i.test(path)
export function popupAppearance(display:Record<string,any>,device:'desktop'|'mobile',pages:number,visitStart:number,now:number,trigger:'automatic'|'exit'='automatic') {
 const a=display.appearance || {},mode=a.mode||'legacy'
 const number=(v:any,f:number)=>Number.isFinite(Number(v))?Math.max(0,Number(v)):f
 if(mode==='engaged') {
  const elapsed=now-(a.timeScope==='page'?Number(a.pageStartedAt||visitStart):visitStart)
  const minimum=device==='mobile'?number(a.mobileDelayMs,30000):number(a.delayMs,20000)
  const scroll=number(display.currentScrollPercent,0)>=number(a.minScrollPercent,30)
  const pageCount=pages>=number(a.minPages,2)
  const engagement=a.engagement==='scroll'?scroll:a.engagement==='pages'?pageCount:scroll||pageCount
  const exitFallback=device==='desktop'&&trigger==='exit'&&Boolean(a.desktopExitIntent)&&!a.exitOnly
  const requiredTime=exitFallback?number(a.exitDelayMs,10000):minimum
  const ready=elapsed>=requiredTime&&engagement&&!a.manualOnly
  return {delay:a.manualOnly||a.exitOnly?null:Math.max(0,minimum-elapsed),exit:device==='desktop'&&!a.manualOnly&&Boolean(a.exitOnly||a.desktopExitIntent),ready}
 }
 if(mode==='legacy')return {delay:number(display.delayMs,1200),exit:false}
 const delay=device==='mobile'?Math.min(86400000,Math.max(1000,number(a.mobileDelayMs,18000))):Math.min(86400000,number(a.delayMs,18000))
 if(device==='mobile')return {delay,exit:false}
 const remaining=a.timeScope==='page'?delay:Math.max(0,delay-(now-visitStart))
 const pagesReached=pages>=Math.max(1,Math.floor(number(a.minPages,2)))
 return {delay:mode==='pages'?(pagesReached?0:null):mode==='exit'?null:mode==='any'&&pagesReached?0:remaining,exit:mode==='exit'||Boolean(a.desktopExitIntent)}
}

export function knownPopupSubscriber():boolean {
 if(popupStore.read(`journey-popup:${popupEnvironment}:subscriber`))return true
 // The legacy newsletter store has no environment tag. Only use it in production.
 if(popupEnvironment!=='prod')return false
 try{return JSON.parse(popupStore.read('email-capture-storage')||'{}')?.state?.modalState?.hasSubscribed===true}catch{return false}
}

// A browser-level suppression flag is not proof that a different checkout
// address subscribed. Keep recognition scoped to the submitted email and mode.
export function rememberPopupSubscriber(email: string) {
 const normalized = email.trim().toLowerCase()
 if (!normalized) return
 popupStore.write(`journey-popup:${popupEnvironment}:subscriber`, '1')
 popupStore.write(`journey-popup:${popupEnvironment}:subscriber-email`, normalized)
}
export function popupSubscriberMatchesEmail(email: string, offerSignupEmail?: string): boolean {
 const normalized = email.trim().toLowerCase()
 if (!normalized || !knownPopupSubscriber()) return false
 const recorded = popupStore.read(`journey-popup:${popupEnvironment}:subscriber-email`)
 return normalized === (recorded || offerSignupEmail || '').trim().toLowerCase()
}
